import { doubleEncode, makePatchRequest } from "../../utils";

type AdditionalHeaders = {
	key: string;
	value: string;
};

type SipHeaders = {
	from_display_name: string;
	to_display_name: string;
	from_uri: string;
};

type H323Headers = {
	from_display_name: string;
	to_display_name: string;
};

type InviteOptions = {
	require_greeting?: boolean;
	require_pressing_one?: boolean;
	call_type?: "h323" | "sip";
	device_ip?: string;
	h323_headers?: H323Headers;
	sip_headers?: SipHeaders;
	additional_headers?: AdditionalHeaders[];
};

type Params = {
	invitee_name?: string;
	phone_number?: string;
	invite_options?: InviteOptions;
};

type In_SessionEventsControlsOptions = {
	sessionId: string;
	method:
	| "recording.start"
	| "recording.stop"
	| "recording.pause"
	| "recording.resume"
	| "user.invite.callout"
	| "user.invite.room_system_callout";
	params?: Params;
};
const useIn_SessionEventsControls = async (
	token: string,
	options: In_SessionEventsControlsOptions,
) => {
	await makePatchRequest({
		token,
		pathList: [
			"v2",
			"videosdk",
			"sessions",
			doubleEncode(options.sessionId),
			"events",
		],
		options: {},
		body: {
			method: options.method,
			params: options.params,
		},
	});
	return 202;
};

export const curriedUseIn_SessionEventsControls = (token: string) => (
	options: In_SessionEventsControlsOptions,
) => useIn_SessionEventsControls(token, options);